import { render, staticRenderFns } from "./FreezeDialog.vue?vue&type=template&id=4cbabfbc"
import script from "./FreezeDialog.vue?vue&type=script&lang=ts"
export * from "./FreezeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports